/**
 * Session shape for trade/position thunks — uses getSessionData() (TradeSession + fxbazzar_* parity).
 * Adds userIp from JWT payload when not on the session object (position close / rollover).
 */

import { getSessionData } from "./common";
import { safeParseInt } from "./numberParse";

export function getNormalizedThunkSession() {
  const d = getSessionData() || {};
  const userId = safeParseInt(d.userId ?? d.id ?? d.UserId);
  const roles = d.roles || d.Roles || [d.role || d.Role || "User"];
  const token = d.token || d.Token || "";
  let userIp = d.userIpFinal || d.userIp || d.UserIp || d.ip || d.IP || "";
  if (!userIp && token) {
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      userIp = payload.IP || payload.ip || "";
    } catch {
      userIp = "";
    }
  }
  return { userId, roles, token, userIp, userIpFinal: userIp };
}
